var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5L8 9.5L7 9.5L7 8.5L6 8.5L6 7.5L5 7.5L5 6.5L4 6.5L4 5.5L5 5.5L5 4.5L6 4.5L6 3.5L7 3.5L7 2.5L8 2.5L8 3.5L7 3.5L7 4.5L6 4.5L6 5.5L5 5.5L5 6.5L6 6.5L6 7.5L7 7.5L7 8.5L8 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftS);
export default __webpack_public_path__ + "static/media/arrow-left-s.d141f15f81a4d7576cf9f074770888c2.svg";
export { ForwardRef as ReactComponent };